import {RootState} from "../../configureStore";
import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";

import _ from "lodash";
import {Workbook} from "../../types/Storyboard";
import {apiFetchWorkbooks} from "../../actions/storyboardApi";

interface StoryboardState {
    createWorkbook: boolean | undefined
    editWorkbook: boolean | undefined
    workbook: Workbook | undefined
    workbooks: Workbook[] | undefined
}

const initialState: StoryboardState = {
    createWorkbook: undefined,
    editWorkbook: undefined,
    workbook: undefined,
    workbooks: undefined
}

export const fetchWorkbooks = createAsyncThunk(
    'storyboard/fetchWorkbooks',
    async () => {
        return apiFetchWorkbooks()
    }
)

export const storyboardSlice = createSlice({
    name: 'storyboard',
    initialState,
    reducers: {
        setCreateWorkbook: (state, action: PayloadAction<boolean>) => {
            state.createWorkbook = action.payload
        },
        setEditWorkbook: (state, action: PayloadAction<boolean>) => {
            state.editWorkbook = action.payload
        },
        setWorkbook: (state, action: PayloadAction<Workbook | undefined>) => {
            state.workbook = action.payload
            state.createWorkbook = false
            state.editWorkbook = false
        }
    },
    extraReducers: builder => {
        builder.addCase(fetchWorkbooks.pending, (state, action) => {
            if (!_.isNil(state.workbooks)) {
                state.workbooks = undefined
            }
        })
        builder.addCase(fetchWorkbooks.fulfilled, (state, action) => {
            state.workbooks = action.payload
        })
    }
})

export const { setCreateWorkbook, setEditWorkbook, setWorkbook } = storyboardSlice.actions;
export const selectCreateWorkbook = (state: RootState) => state.storyboard.createWorkbook
export const selectEditWorkbook = (state: RootState) => state.storyboard.editWorkbook
export const selectWorkbook = (state: RootState) => state.storyboard.workbook
export const selectWorkbooks = (state: RootState) => state.storyboard.workbooks
export default storyboardSlice.reducer